import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()
export class SvcInterceptor implements HttpInterceptor {

    constructor(private router: Router) { /* noop */
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            tap(
                () => {
                    /* noop */
                },
                (err: any) => {
                    if (err.status === 401 || err.status === 403 || err.status === 0) {
                        this.router.navigate(['/login']);
                    }
                })
        );
    }
}
